import { createSlice } from "@reduxjs/toolkit";
import { submitSignUp ,submitLogin ,ResendOtp,VerifyOtp ,serviceInsert,verifyEmail,logout,SessionExpired} from "../api/SignupApi";

const authSlice = createSlice({
    name: "authSlice",
    initialState: {
      loading: false,
      signup_detail:'',
      Login_detail: "",
 
    },
    reducers:{
        signup_details :(state, action)=>{
        state.signup_detail="";
      
        },

        Login_detail :(state, action)=>{
          state.Login_detail="";
          }

    },

    extraReducers: (builder) => {
      builder.addCase(submitSignUp.pending, state => {
        state.loading = true
      })
      builder.addCase(submitSignUp.fulfilled,  (state, action) => {
       state.signup_detail=action.payload;
        state.loading = false
      })
      builder.addCase(submitSignUp.rejected, (state,action) => {
      
        state.loading = false
      })

      builder.addCase(verifyEmail.pending, state => {
        state.loading = true
      })
      builder.addCase(verifyEmail.fulfilled,  (state, action) => {
      
        state.loading = false
      })
      builder.addCase(verifyEmail.rejected, (state,action) => {
      
        state.loading = false
      })

      builder.addCase(submitLogin.pending, state => {
         state.loading = true
       })
       builder.addCase(submitLogin.fulfilled,  (state, action) => {
        state.Login_detail=action.payload;
        state.loading = false
       })
       builder.addCase(submitLogin.rejected, (state,action) => {
        state.Login_detail=action.error;
         state.loading = false
      
       })

// api for resendotp---------
       builder.addCase(ResendOtp.pending, state => {
         state.loading = true
       })
       builder.addCase(ResendOtp.fulfilled,  (state, action) => {
        state.loading = false
       })
       builder.addCase(ResendOtp.rejected, (state,action) => {
         state.loading = false
       })


       // api for verifyOtp---------
       builder.addCase(VerifyOtp.pending, state => {
        state.loading = true
      })
      builder.addCase(VerifyOtp.fulfilled,  (state, action) => {
       state.loading = false
      })
      builder.addCase(VerifyOtp.rejected, (state,action) => {
        state.loading = false
      })

       // api for service insert---------
       builder.addCase(serviceInsert.pending, state => {
        state.loading = true
      })
      builder.addCase(serviceInsert.fulfilled,  (state, action) => {
       state.loading = false
      })
      builder.addCase(serviceInsert.rejected, (state,action) => {
        state.loading = false
      })


      builder.addCase(logout.pending, state => {
        state.loading = true
      })
      
      builder.addCase(logout.fulfilled,  (state, action) => {
       state.loading = false
      
      })
      builder.addCase(logout.rejected, (state,action) => {
        state.loading = false
      })

      
      // SessionExpired

      builder.addCase(SessionExpired.pending, state => {
        state.loading = true
      })
      
      builder.addCase(SessionExpired.fulfilled,  (state, action) => {
       state.loading = false
      
      })
      builder.addCase(SessionExpired.rejected, (state,action) => {
        state.loading = false
      })
    }
  })

  //Actions
  export const { signup_details } = authSlice.actions;
  
  //Reducer
  export default authSlice.reducer;